import { ApolloLink } from '@apollo/client'

import firebase from './firebase'

function getOperationName(query) {
  return query.definitions.find(
    def => def.kind === 'OperationDefinition' && def.name,
  )?.name.value
}

const FirebasePerformanceLink = new ApolloLink((operation, forward) => {
  const operationName = getOperationName(operation.query)

  const trace = firebase.getTrace(`menu_curator_graphQl_${operationName}`)
  trace.start()

  return forward(operation).map(response => {
    trace.stop()

    return response
  })
})

export default FirebasePerformanceLink
